import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';

import { restoreStatement } from '../../api';

export const useMutationRestoreStatement = () => {
  const queryClient = useQueryClient();
  const { successToast, errorToast } = useCustomToast();
  const { t } = useTranslation();

  return useMutation(restoreStatement, {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.RENTALS_CALCULATION_STATEMENTS);

      successToast(t('Item successfully restored'));
    },
    onError: () => errorToast(),
  });
};
